import React from 'react';
import WarningIcon from '@mui/icons-material/Warning';
import { Tooltip } from '@mui/material';
import FilterProduct from '../domain/filterproduct';
import { IsProductStandard } from '../common/productdataparse';
import { useTranslation } from 'react-i18next';

const styles = {
    warningLegacy: {
        color: 'orange',
        verticalAlign: 'middle',
        display: 'inline-flex',
        fontSize: '1.25em',
    },
};

const FilterProductWarning = ({ product, bundle, locContractPriceInUse, contractPriceInUse }) => {
    const { t } = useTranslation();

    if (bundle)
        return (
            <React.Fragment>
                {bundle.isExpired() && (
                    <Tooltip title={t('product.bundleRemovedFromCatalogWarning', { productName: bundle.name })}>
                        <WarningIcon sx={styles.warningLegacy} name="warningIcon-bundleExpired" />
                    </Tooltip>
                )}
                {!bundle.isExpired() && locContractPriceInUse && !contractPriceInUse && (
                    <Tooltip title={t('product.nonContractBundleProductWarning', { productName: bundle.name })}>
                        <WarningIcon sx={styles.warningLegacy} name="warningIcon-nonContractBundle" />
                    </Tooltip>
                )}
            </React.Fragment>
        );
    if (product)
        return (
            <React.Fragment>
                {product.expired && (
                    <Tooltip
                        title={t('product.productRemovedFromCatalogWarning', { productName: product.productName })}>
                        <WarningIcon sx={styles.warningLegacy} name="warningIcon-expired" />
                    </Tooltip>
                )}
                {!product.expired && product.productCode !== '0' && (
                    <Tooltip title={t('product.tooOldProductWarning')}>
                        <WarningIcon sx={styles.warningLegacy} name="warningIcon-tooOld" />
                    </Tooltip>
                )}
                {!product.expired && product.status === FilterProduct.StatusDraftRequest() && (
                    <Tooltip title={t('product.draftProductWarning')}>
                        <WarningIcon sx={styles.warningLegacy} name="warningIcon-draft" />
                    </Tooltip>
                )}
                {!product.expired && product.status === FilterProduct.StatusImported() && (
                    <Tooltip title={t('product.temporaryProductFromImportWarning')}>
                        <WarningIcon sx={styles.warningLegacy} name="warningIcon-imported" />
                    </Tooltip>
                )}
                {!product.expired && !IsProductStandard(product) && (
                    <Tooltip title={t('product.notStandardWarning')}>
                        <WarningIcon sx={styles.warningLegacy} name="warningIcon-notStandard" />
                    </Tooltip>
                )}
                {!product.expired && locContractPriceInUse && !contractPriceInUse && (
                    <Tooltip title={t('product.nonContractProductWarning', { productName: product.productName })}>
                        <WarningIcon sx={styles.warningLegacy} name="warningIcon-nonContract" />
                    </Tooltip>
                )}
            </React.Fragment>
        );
    return null;
};

export default FilterProductWarning;
